import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/feedback', { params }),
}
